import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../shared/form-elements/input';
import SelectField from '../../shared/form-elements/select/field';

const propTypes = {
	intl: PropTypes.func,
	formData: PropTypes.object,
	locationsLookup: PropTypes.func,
	managersLookup: PropTypes.func,
	timezonesLookup: PropTypes.func,
	submitForm: PropTypes.func,
	handleSubmit: PropTypes.func
};

const Form = ({
	intl,
	handleSubmit,
	currenciesOptions,
	can,
	cancelForm,
	submitForm
}) => (
	<form className="ui-form exchange-main__form" onSubmit={handleSubmit(data => submitForm(data))}>
		{
			['selling_rate', 'buying_rate'].map((c, index) => (
				<div className="ui-form__element" key={index}>
					<Field
						intl={intl}
						name={c}
						placeholder={index === 0 ? 'Selling rate (USD)' : 'Buying rate (USD)'}
						normalize={(value, previousValue) => {
							if (!value) return '';
							const fractialPart = value.toString().split('.')[1];
							const reg = /^[\d.,]+$/;

							if (fractialPart && fractialPart.length > 4 || !reg.test(value)) {
								return previousValue;
							}

							return value.replace(/,/, '.');
						}}
						disabled={!can('edit')}
						component={InputField}
					/>
				</div>
			))
		}
		{
			process.env.CPA_ENV !== 'rocket' &&
			<div className="margin-0-15 width-100">
				<Field
					name="currency"
					placeholder="Currency"
					searchable={false}
					multi={false}
					clearable={false}
					component={SelectField}
					options={currenciesOptions}
				/>
			</div>
		}
		<div className="ui-form__element exchange__controls">
			{can('edit') && <button className="ui-btn ui-btn-primary">{ intl('Save') }</button>}
			<button type="button" className="ui-btn ui-btn-cancel" onClick={cancelForm}>
				{intl('Cancel')}
			</button>
		</div>
	</form>
);

Form.propTypes = propTypes;
export default reduxForm({
	form: 'exchangeCurrencyForm',
	enableReinitialize : true
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/exchange-rates/components/form.js